import Sparkle from '../../src/legacy/Sparkle';
export default Sparkle;
